// test2324
(2324 && 0);
